import React from 'react'

const BlueShareIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <mask
        id="mask0_317_30119"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_317_30119)">
        <path
          d="M15 18.3332C14.3056 18.3332 13.7153 18.0901 13.2292 17.604C12.7431 17.1179 12.5 16.5276 12.5 15.8332C12.5 15.7359 12.5069 15.6351 12.5208 15.5307C12.5347 15.4268 12.5556 15.3332 12.5833 15.2498L6.70833 11.8332C6.47222 12.0415 6.20833 12.2046 5.91667 12.3223C5.625 12.4407 5.31944 12.4998 5 12.4998C4.30556 12.4998 3.71528 12.2568 3.22917 11.7707C2.74306 11.2846 2.5 10.6943 2.5 9.99984C2.5 9.30539 2.74306 8.71511 3.22917 8.229C3.71528 7.74289 4.30556 7.49984 5 7.49984C5.31944 7.49984 5.625 7.55873 5.91667 7.6765C6.20833 7.79484 6.47222 7.95817 6.70833 8.1665L12.5833 4.74984C12.5556 4.6665 12.5347 4.57289 12.5208 4.469C12.5069 4.36456 12.5 4.26373 12.5 4.1665C12.5 3.47206 12.7431 2.88178 13.2292 2.39567C13.7153 1.90956 14.3056 1.6665 15 1.6665C15.6944 1.6665 16.2847 1.90956 16.7708 2.39567C17.2569 2.88178 17.5 3.47206 17.5 4.1665C17.5 4.86095 17.2569 5.45123 16.7708 5.93734C16.2847 6.42345 15.6944 6.6665 15 6.6665C14.6806 6.6665 14.375 6.60734 14.0833 6.489C13.7917 6.37123 13.5278 6.20817 13.2917 5.99984L7.41667 9.4165C7.44444 9.49984 7.46528 9.59345 7.47917 9.69734C7.49306 9.80178 7.5 9.90261 7.5 9.99984C7.5 10.0971 7.49306 10.1976 7.47917 10.3015C7.46528 10.4059 7.44444 10.4998 7.41667 10.5832L13.2917 13.9998C13.5278 13.7915 13.7917 13.6282 14.0833 13.5098C14.375 13.3921 14.6806 13.3332 15 13.3332C15.6944 13.3332 16.2847 13.5762 16.7708 14.0623C17.2569 14.5484 17.5 15.1387 17.5 15.8332C17.5 16.5276 17.2569 17.1179 16.7708 17.604C16.2847 18.0901 15.6944 18.3332 15 18.3332Z"
          fill="#3249D7"
        />
      </g>
    </svg>
  )
}

export default BlueShareIcon
